import Female from '@/assets/images/Female.svg';
import Male from '@/assets/images/Male.svg';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Gender, User } from '@/Types/gql/graphql';
import { Star } from 'lucide-react';
import React from 'react';
import { Link } from 'react-router-dom';

interface TrainerCardProps {
  trainer?: Pick<
    User,
    '_id' | 'gender' | 'lastName' | 'firstName' | 'displayName' | 'profileImage' | 'averageRating'
  >;
}

const TrainerCard: React.FC<TrainerCardProps> = ({ trainer }) => {
  return (
    <Link key={trainer?._id} to={`/trainers/${trainer?._id}`}>
      <div className='flex flex-col gap-3'>
        <Card className='overflow-hidden border-none'>
          <CardContent className='p-0'>
            <div className='relative aspect-square'>
              <img
                src={
                  trainer?.profileImage
                    ? trainer.profileImage
                    : trainer?.gender === Gender.Female
                      ? Female
                      : Male
                }
                alt={trainer?.displayName || ''}
                width={200}
                height={200}
                className='object-cover w-full h-full'
              />
              <div
                className='absolute top-2 right-2 rounded-lg flex items-center gap-1 px-2 py-[6px]'
                style={{ backdropFilter: 'blur(5.5px)', background: '#343840A8' }}
              >
                <Star className='h-3 w-3 fill-yellow-400 stroke-yellow-400' />
                <span className='text-xs text-white leading-none font-medium'>
                  {/* {trainer?.averageRating ? trainer.averageRating : 5} */}5
                </span>
              </div>
            </div>
          </CardContent>
        </Card>
        <h5>{trainer?.firstName}</h5>
      </div>
    </Link>
  );
};

export const TrainerCardSkeleton = () => {
  return (
    <div className='flex flex-col gap-3'>
      <Card className='overflow-hidden border-none'>
        <CardContent className='p-0'>
          <div className='relative aspect-square'>
            <Skeleton className='w-full h-full bg-bgSecondary' />
          </div>
        </CardContent>
      </Card>
      <Skeleton className='w-24 h-5 bg-bgSecondary' />
    </div>
  );
};

export default TrainerCard;
